export const langs = ['en'];
export const locales = ['us'];

const [fallback_lang] = langs;
const [fallback_locale] = locales;

export { fallback_lang, fallback_locale };
